import React, { useState } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
} from "@mui/material";

const AddPitched = () => {
  const [pitchedData, setPitchedData] = useState({
    pitchedName: "",
    contactNo: "",
    pitchedEmail: "",
    pitchedLocation: "",
    pitchedSource: "",
    pitchedComments: "",
    changeStatus: "",
    status: "active",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPitchedData({ ...pitchedData, [name]: value });
  };

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberRegex = /^[0-9]+$/;

    if (
      pitchedData.pitchedEmail.trim() !== "" &&
      !emailRegex.test(pitchedData.pitchedEmail)
    ) {
      return false;
    }

    if (
      pitchedData.contactNo.trim() !== "" &&
      !numberRegex.test(pitchedData.contactNo)
    ) {
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate() && pitchedData.pitchedName.trim() !== "") {
      try {
        const response = await axiosInstance.post(
          "/api/addPitched",
          pitchedData
        );

        if (response.status === 201) {
          setOpenSnackbar(true);
          setSubmitMessage("Pitched data saved successfully!");

          setPitchedData({
            pitchedName: "",
            contactNo: "",
            pitchedEmail: "",
            pitchedLocation: "",
            pitchedSource: "",
            pitchedComments: "",
            changeStatus: "",
            status: "active",
          });
        } else {
          console.error(
            "Failed to save pitched data - Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data); // Log response data for further insight
          setOpenSnackbar(true);
          setSubmitMessage("Failed to save pitched data. Please try again.");
        }
      } catch (error) {
        console.error("Error occurred:", error);
        setOpenSnackbar(true);
        setSubmitMessage(
          "An unexpected error occurred. Please try again later."
        );
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="Pitched Name"
        name="pitchedName"
        value={pitchedData.pitchedName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        label="Contact Number"
        name="contactNo"
        value={pitchedData.contactNo}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
        type="tel"
        inputProps={{ pattern: "[0-9]{10}", maxLength: 10 }}
      />
      <TextField
        label="Pitched Email"
        name="pitchedEmail"
        value={pitchedData.pitchedEmail}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
        type="email"
      />
      <TextField
        label="Pitched Location"
        name="pitchedLocation"
        value={pitchedData.pitchedLocation}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Pitched Source"
        name="pitchedSource"
        value={pitchedData.pitchedSource}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Pitched Comments"
        name="pitchedComments"
        value={pitchedData.pitchedComments}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        multiline
        rows={4}
      />
      <FormControl
        fullWidth
        margin="normal"
      >
        <InputLabel>Status</InputLabel>
        <Select
          name="status"
          value={pitchedData.status} // Change this line
          onChange={handleInputChange}
        >
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </Select>
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        type="submit"
      >
        Save
      </Button>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        message={submitMessage}
      />
    </form>
  );
};

export default AddPitched;
